import { createFileRoute } from "@tanstack/react-router";
import { m } from "#/paraglide/messages";
import {
  useGetBlModifiedFranceAvailableFiles,
  useSearchBlModifiedFranceOrders,
} from "#/lib/api/bl-modified-france";
import { BlModifiedFranceOrderSearchSchema } from "#/lib/schemas/bl-modified-france-search";
import { BlModifiedFrancePage } from "#/components/pages/bl-modified-france/bl-modified-france-page";

export const Route = createFileRoute("/$tenantCode/$market/bl-modified-france")(
  {
    validateSearch: BlModifiedFranceOrderSearchSchema,
    beforeLoad: () => ({
      getTitle: () => m["resources.blModifiedFrance.name"](),
    }),
    component: BlModifiedFranceRoute,
  },
);

function BlModifiedFranceRoute() {
  const { page, perPage, sort } = Route.useSearch();

  const { data, isLoading } = useSearchBlModifiedFranceOrders({
    page,
    limit: perPage,
    sort,
  });

  const { data: availableFiles } = useGetBlModifiedFranceAvailableFiles();

  const orders = data?.data ?? [];
  const totalItems = data?.meta?.totalItems ?? 0;
  const totalPages = data?.meta?.totalPages ?? 0;

  return (
    <BlModifiedFrancePage
      orders={orders}
      totalItems={totalItems}
      pageCount={totalPages}
      isLoading={isLoading}
      availableFiles={availableFiles}
    />
  );
}
